import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import _ from "lodash";

import EmptyMessage from "src/components/emptyMessage";

import styles from "./styles.module.scss";

const Opportunities = () => {
  const { opportunityId } = useParams();
  const navigate = useNavigate();


  useEffect(() => {
    if (!opportunityId) {
      if (_.get(window, 'location.pathname', '').includes('/lite/msdynamics')) {
        navigate('/msdynamics/opportunities');
      } else {
        navigate('/opportunities');
      }
    }
  }, [opportunityId]);

  if (!opportunityId) {
    return (
      <div className={styles.container}>
        <EmptyMessage
          width="auto"
          image={'/images/page_not_found.svg'}
          heading="Opportunity knocks… but not yet!"
          message="Create this opportunity to track shares and get smart recommendations."
        />
      </div>
    );
  }

  return (
    <Outlet />
  );
}

export default Opportunities;